import React, { FC, useState } from "react";
import Register from "./Register";
import { useNavigate } from "react-router-dom";
import { GoArrowLeft } from "react-icons/go";
import { validateForgotPassword } from "../utils/validations";
import { useMutation } from "@tanstack/react-query";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-hot-toast";
import { API } from "../constants/api";
import useAuthAxios from "../utils/baseAxios";
import { errorMessage } from "../utils/errorMessage";

const ForgotPassword: FC = () => {
  const [email, setEmail] = useState<string>("");
  const navigate = useNavigate();
  const axiosInstance = useAuthAxios();

  const handleForgotPassword = async () => {
    const response = await axiosInstance.post(API.forgotPassword, { email });
    return response.data;
  };
  const completeForgotPassword = useMutation({
    mutationFn: handleForgotPassword,
    onSuccess: (r) => {
      toast.success(r.message);

      setTimeout(() => {
        navigate("/reset-password", {
          state: {
            email,
          },
        });
      }, 2000);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });

  const handleSubmit = () => {
    if (!validateForgotPassword(email)) {
      return;
    }

    completeForgotPassword.mutate();
  };

  return (
    <div className="w-full mds:w-4/5 md:w-3/5 xxxl:w-[50%] px-6 lgss:px-0 pt-28 pb-20 lgss:pt-16 font-manrope h-full mx-auto flex-col justify-between  items-center  flex">
      <div className="flex flex-col justify-center  items-center   w-full">
        <div className="flex justify-start items-start w-full px-4 lgss:px-8">
          <GoArrowLeft
            onClick={() => {
              navigate(-1);
            }}
            className="text-[#13181B] dark:text-gray-300 cursor-pointer text-[20px]"
          />
        </div>
        <h2 className="text-text_black w-full px-5 lgss:px-0 lgss:w-1/2 xxxl:w-2/5 dark:text-gray-200  font-sora text-2xl text-center font-bold mt-16 lgss:mt-24 lgss:pt-0 ">
          👀 Forgot Password
        </h2>
        <h4 className="text-[#617889] mt-1 dark:text-gray-300 font-manrope text-[13px] font-semibold pt-4 lgss:pt-0">
          Confirm your email and we’d send you instructions
        </h4>
        <form className="mt-6 w-full px-5 lgss:px-0 lgss:w-1/2 xxxl:w-2/5">
          <label className="relative">
            <input
              type="email"
              value={email}
              placeholder="Email"
              onChange={(e) => {
                setEmail(e.target.value.toLowerCase());
              }}
              name="email"
              className="h-[50px] dark:bg-[#1F2B36] dark:text-[white]  dark:border-[#095B97] dark:focus:bg-[#1F2B36] w-full   px-[16px] font-manrope border-2 rounded-lg border-[#4A4A68] outline-none focus:border-blue-600 text-[#4A4A68] transition duration-200"
            />
          </label>
        </form>
      </div>
      <div className="w-full mds:w-[90%] lgss:w-1/2 xxxl:w-2/5 flex flex-col justify-center items-center">
        <h4 className="font-manrope dark:text-gray-300 tracking-wider text-text_black font-medium text-sm pt-6">
          Don’t have an account?{" "}
          <span
            onClick={() => {
              navigate("/signup");
            }}
            className="underline text-secondary_button tracking-wider cursor-pointer"
          >
            Sign Up
          </span>
        </h4>

        <button
          onClick={handleSubmit}
          disabled={completeForgotPassword.isPending}
          className="w-full  h-[52px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-secondary_button mt-8 lgss:mt-8"
        >
          {completeForgotPassword.isPending ? (
            <ClipLoader color="#FFFFFF" size={30} />
          ) : (
            "Send"
          )}
        </button>
      </div>
    </div>
  );
};
const ForgotPasswordPage = () => (
  <div className="lgss:flex lgss:flex-row h-screen dark:bg-[#13181B]">
    <Register />
    <ForgotPassword />
  </div>
);
export default ForgotPasswordPage;
